import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1374df6f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-box d-flex" }

import { computed } from 'vue';
  import { useRoute } from 'vue-router';
  import { NavbarType } from '@/types/navbar';

  // 使用非 router-link 时，active通过 activeItemKey 从外部控制即可
  interface IProps {
    navbar: NavbarType[];
    activeItemKey?: string;
    routerQueryKey?: string;
    isRouterLink?: boolean
  }

  interface Emits {
    (e: 'change', item: NavbarType): void
    (e: 'clickItem', item: NavbarType): void
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    navbar: null,
    activeItemKey: null,
    routerQueryKey: { default: 'type' },
    isRouterLink: { type: Boolean, default: true }
  },
  emits: ["change", "clickItem"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'change', item: NavbarType): void
    (e: 'clickItem', item: NavbarType): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { navbar: NavbarType[], activeItemKey?: string, routerQueryKey: string, isRouterLink: boolean }

  const route = useRoute();
  

  

  const activeKey = computed<string>(() => {
    if (props.isRouterLink) {
      return (route.query[props.routerQueryKey] as string) || props.navbar[0].key;
    }
    return props.activeItemKey as string;
  });

  function handleClick(item: NavbarType) {
    emits('clickItem', item);
    if (item.key !== activeKey.value) {
      emits('change', item);
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.navbar, (item, index) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(props.isRouterLink ? 'router-link' : 'div'), {
        key: index,
        class: _normalizeClass(["nav-item", { active: item.key === _unref(activeKey) }]),
        replace: "",
        to: { query: { [__props.routerQueryKey]: item.key } },
        onClick: ($event: any) => (handleClick(item))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(item.name), 1)
        ]),
        _: 2
      }, 1032, ["class", "to", "onClick"]))
    }), 128))
  ]))
}
}

})